<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="balance-log-table-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 搜索栏 -->
        <div
          class="search-bar"
          style="
            margin-bottom: 20px;
            display: flex;
            gap: 10px;
            align-items: center;
            flex-wrap: wrap;
          "
        >
          <el-input
            v-model="searchParams.user_id"
            placeholder="请输入用户ID"
            clearable
            style="width: 200px"
          ></el-input>

          <el-select
            v-model="searchParams.type"
            placeholder="请选择类型"
            clearable
            style="width: 220px"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.type"
              :label="item.desc"
              :value="item.type"
            ></el-option>
          </el-select>

          <el-select
            v-model="searchParams.mode"
            placeholder="请选择模式"
            clearable
            style="width: 200px"
          >
            <el-option label="增加" :value="1"></el-option>
            <el-option label="减少" :value="2"></el-option>
          </el-select>

          <el-button type="primary" @click="getList">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </div>

        <!-- 表格 -->
        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%"
          @row-click="handleRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="120"
            align="center"
          />
          <el-table-column
            label="类型名称"
            prop="type_name"
            width="180"
            align="center"
          />

          <el-table-column
            label="变动闯关币"
            prop="amount"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <span
                :style="{
                  color: scope.row.mode == 1 ? '#67c23a' : '#f56c6c',
                  fontWeight: 'bold',
                }"
              >
                {{ scope.row.mode == 1 ? "+" : "-" }}{{ scope.row.amount }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            label="变动后闯关币"
            prop="after_amount"
            width="160"
            align="center"
          />
          <el-table-column label="模式" width="100" align="center">
            <template slot-scope="scope">
              <span
                :style="{
                  color: scope.row.mode == 1 ? '#67c23a' : '#f56c6c',
                  fontWeight: 'bold',
                }"
              >
                {{ scope.row.mode == 1 ? "增加" : "减少" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remark" min-width="220" show-overflow-tooltip />
          <el-table-column label="创建时间" prop="created_at" width="180" />
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC详情弹窗 -->
        <el-dialog
          title="闯关币记录详情"
          :visible.sync="detailVisible"
          width="620px"
          append-to-body
        >
          <el-form :model="detailForm" label-width="120px" size="small">
            <el-form-item label="记录ID">
              <span>{{ detailForm.id }}</span>
            </el-form-item>
            <el-form-item label="用户ID">
              <span>{{ detailForm.user_id }}</span>
            </el-form-item>
            <el-form-item label="类型名称">
              <span>{{ detailForm.type_name }}</span>
            </el-form-item>
            <el-form-item label="变动闯关币">
              <span
                :style="{
                  color: detailForm.mode == 1 ? '#67c23a' : '#f56c6c',
                  fontWeight: 'bold',
                }"
              >
                {{ detailForm.mode == 1 ? "+" : "-" }}{{ detailForm.amount }}
              </span>
            </el-form-item>
            <el-form-item label="变动后闯关币">
              <span>{{ detailForm.after_amount }}</span>
            </el-form-item>
            <el-form-item label="模式">
              <span
                :style="{
                  color: detailForm.mode == 1 ? '#67c23a' : '#f56c6c',
                  fontWeight: 'bold',
                }"
              >
                {{ detailForm.mode == 1 ? "增加" : "减少" }}
              </span>
            </el-form-item>
            <el-form-item label="扩展ID">
              <span>{{ detailForm.ext_id || "-" }}</span>
            </el-form-item>
            <el-form-item label="扩展标识">
              <span>{{ detailForm.ext || "-" }}</span>
            </el-form-item>
            <el-form-item label="备注">
              <span>{{ detailForm.remark || "-" }}</span>
            </el-form-item>
            <el-form-item label="创建时间">
              <span>{{ detailForm.created_at }}</span>
            </el-form-item>
            <el-form-item label="更新时间">
              <span>{{ detailForm.updated_at || "-" }}</span>
            </el-form-item>
          </el-form>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-log-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 移动端搜索 -->
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.user_id"
            placeholder="用户ID"
            clearable
            size="medium"
            prefix-icon="el-icon-user"
          />
          <el-select
            v-model="searchParams.type"
            placeholder="记录类型"
            clearable
            size="medium"
            style="margin-top: 8px"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.type"
              :label="item.desc"
              :value="item.type"
            />
          </el-select>
          <el-select
            v-model="searchParams.mode"
            placeholder="操作类型"
            clearable
            size="medium"
            style="margin-top: 8px"
          >
            <el-option label="增加" :value="1" />
            <el-option label="减少" :value="2" />
          </el-select>

          <div style="display: flex; gap: 8px; margin-top: 10px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
            >搜索</el-button>
            <el-button plain round @click="resetSearch" style="flex: 1">重置</el-button>
          </div>
        </div>

        <!-- 移动端卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-top">
              <div class="id-info">
                <span>ID：{{ item.id }}</span>
                <span class="type-tag">{{ item.type_name }}</span>
              </div>
              <div class="amount" :class="item.mode == 1 ? 'add' : 'reduce'">
                {{ item.mode == 1 ? "+" : "-" }}{{ item.amount }}
              </div>
            </div>

            <div class="card-middle">
              <div>用户ID：{{ item.user_id }}</div>
              <div>操作：{{ item.mode == 1 ? "增加" : "减少" }}</div>
              <div>变动后闯关币：{{ item.after_amount }}</div>
            </div>

            <div class="card-bottom">
              <div class="time">{{ item.created_at }}</div>
              <div class="remark" v-if="item.remark">
                备注：{{ item.remark }}
              </div>
            </div>
          </div>
        </div>

        <!-- 移动端分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗 -->
        <el-dialog
          title="闯关币详情"
          :visible.sync="mobileDetailVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            v-if="mobileDetailRow"
            :model="mobileDetailRow"
            label-width="100px"
            size="small"
          >
            <el-form-item label="记录ID">{{ mobileDetailRow.id }}</el-form-item>
            <el-form-item label="用户ID">{{ mobileDetailRow.user_id }}</el-form-item>
            <el-form-item label="类型">{{ mobileDetailRow.type_name }}</el-form-item>
            <el-form-item label="变动闯关币">
              <span
                :style="{
                  color: mobileDetailRow.mode == 1 ? '#67c23a' : '#f56c6c',
                  fontWeight: 'bold',
                }"
              >
                {{ mobileDetailRow.mode == 1 ? "+" : "-" }}{{ mobileDetailRow.amount }}
              </span>
            </el-form-item>
            <el-form-item label="变动后">{{ mobileDetailRow.after_amount }}</el-form-item>
            <el-form-item label="操作">{{ mobileDetailRow.mode == 1 ? "增加" : "减少" }}</el-form-item>
            <el-form-item label="扩展ID">{{ mobileDetailRow.ext_id || "-" }}</el-form-item>
            <el-form-item label="扩展标识">{{ mobileDetailRow.ext || "-" }}</el-form-item>
            <el-form-item label="备注">{{ mobileDetailRow.remark || "-" }}</el-form-item>
            <el-form-item label="创建时间">{{ mobileDetailRow.created_at }}</el-form-item>
            <el-form-item label="更新时间">{{ mobileDetailRow.updated_at || "-" }}</el-form-item>
          </el-form>

          <div slot="footer" style="text-align: right">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";

export default {
  name: "FightPointLogList",
  data() {
    return {
      loading: false,
      tableData: [],
      typeOptions: [],
      total: 0,
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
        type: "",
        mode: "",
      },
      // PC弹窗
      detailVisible: false,
      detailForm: {},
      // 移动端弹窗
      mobileDetailVisible: false,
      mobileDetailRow: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        // 闯关币日志接口
        const res = await api.logs.fightPointLog({
          params: this.searchParams,
        });
        if (res.data.code == "1000") {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
          this.typeOptions = res.data.data.type || [];
        }
      } finally {
        this.loading = false;
      }
    },

    handleRowClick(row) {
      this.detailForm = { ...row };
      this.detailVisible = true;
    },

    openMobileDetail(row) {
      this.mobileDetailRow = JSON.parse(JSON.stringify(row));
      this.mobileDetailVisible = true;
    },

    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
        type: "",
        mode: "",
      };
      this.getList();
    },

    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
.balance-log-table-container {
  padding: 20px;
}

.mobile-log-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.id-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.type-tag {
  background: #f5f7fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: #666;
}
.amount {
  font-weight: bold;
  font-size: 16px;
}
.amount.add {
  color: #67c23a;
}
.amount.reduce {
  color: #f56c6c;
}
.card-middle {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}
.card-bottom {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  padding-top: 8px;
  border-top: 1px dashed #f0f0f0;
}
.remark {
  margin-top: 4px;
  color: #888;
}
</style>


// WEBPACK FOOTER //
// src/pages/log/fightPointLog.vue